import React from "react";

import { Stack } from "@mui/material";

import SaveButton from "../CreateTaskWorkflow/SaveButton";
import Button from "@src/multiCustodian/components/MUI/Button/Button";

interface TaskActionButtonsProps {
  onCancel: () => void;
  cancelText?: string;
}

const TaskActionButtons: React.FC<TaskActionButtonsProps> = ({
  onCancel,
  cancelText = "Cancel",
}) => (
  <Stack direction="row" spacing={2}>
    <Button
      variant="outlined"
      buttonType="primary"
      text={cancelText}
      onClick={onCancel}
    />
    <SaveButton />
  </Stack>
);

export default TaskActionButtons;
